import React from "react";
import { Layout, Menu, Button } from "antd";
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";

const { Sider, Content } = Layout;

export type MenuRoute = {
  label: string;
  path: string;
  icon?: React.ReactNode;
};

type SidebarLayoutProps = {
  menuRoutes: MenuRoute[];
};

export default function SidebarLayout({ menuRoutes }: SidebarLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const items: MenuProps["items"] = menuRoutes.map((route) => ({
    key: route.path,
    icon: route.icon,
    label: <Link to={route.path}>{route.label}</Link>,
  }));

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/login");
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={200} style={{ background: "#fff", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "20px", fontWeight: "bold" }}>Kogershin admin</div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          style={{ flex: 1, borderRight: 0 }}
        />
        <div style={{ padding: 16 }}>
          <Button block danger onClick={handleLogout}>
            Выйти
          </Button>
        </div>
      </Sider>
      <Layout style={{ padding: "24px" }}>
        <Content
          style={{
            padding: 24,
            margin: 0,
            minHeight: 280,
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
